<template>
  <div class="profile-info-tab" :class="theme">
    <div class="info-tab">
      <div class="no-scrollbar" style="overflow-y: scroll; height: 100%">

        <!-- <div v-if="user" class="card">
          <p class="field-name">
            {{ $t("Referral Code") }}
            <i class="is-pulled-right has-text-weight-medium" @click="toggleForceSMSOff">
              <span>Refer to win!</span>
            </i>
          </p>
          <i class="fa fa-tags l-icon" />
          <span class="notification-btn pulse-btn has-text-weight-semibold" @click="shareReferralCode">
            <span style="font-size: 0.8em; margin-right: 4px">Share code</span>
            <span class="has-text-black">{{ referralCode }}</span>
            <i class="fa fa-share-alt has-text-link" style="margin-left: 4px" />
          </span>
          <span v-if="referredBy" class="notification-btn" style="font-size: 0.75em; float: right"
            @click="referredByInfo">
            Referred by<br />
            <span style="font-weight: 500">{{ referredBy }}</span>
            <i class="fa fa-check-circle has-text-success" style="margin-left: 4px" />
          </span>
          <span v-else style="float: right" @click="enterReferralCode">
            <span class="link has-text-link" style="
                font-weight: 450;
                font-weight: 0.9em;
                line-height: 1em;
                display: inline-block;
              ">Enter Code</span>
          </span>
        </div> -->

        <div class="card">
          <p class="field-name">
            {{ $t("profile.name") }}
            <i v-if="fullName" class="is-pulled-right has-text-weight-medium">
              <span>{{ fullName }}</span>
            </i>
          </p>
          <i class="fa fa-user l-icon" />
          <span class="single-line no-scrollbar">{{
            $store.getters.realName
          }}</span>
          <span class="button is-small is-warning" style="width: 50vw" v-if="!$store.getters.realName"
            @click="editRealName">{{ $t("profile.name-required") }}</span>
          <i :class="editClass" @click="editRealName" />
        </div>
        <div class="card">
          <p class="field-name">{{ $t("profile.mobile") }}</p>
          <i class="fa fa-mobile l-icon" />
          <span>{{ $store.getters.phoneNumber }}</span>
          <span v-if="pendingMobileUpdate" class="has-text-danger">
            <i class="fa fa-spinner fa-spin has-text-danger" style="margin-left: 6px" />
            Pending
          </span>
          <span v-if="!$store.getters.phoneNumber" class="button is-small is-warning" style="width: 50vw"
            @click="editMobileNumber">{{ $t("profile.mobile-required") }}</span>
          <i :class="editClass" @click="editMobileNumber" />
        </div>
        <!-- <hr /> -->
        <!-- <br /> -->

        <div class="card">
          <p class="field-name">{{ $t("language.language") }}</p>
          <i class="fa fa-globe l-icon" @click="changeLanguage" />
          <span @click="changeLanguage">{{ $store.getters.getLanguage }}</span>
          <i :class="editClass" @click="changeLanguage" />
          <!-- <hr />
        <br /> -->
        </div>
        <div class="card">
          <p class="field-name">{{ $t("profile.home-address") }}</p>
          <i class="fa fa-home l-icon" />
          <span class="single-line no-scrollbar">{{ homeAddress }}</span>
          <i :class="editClass" @click="editAddress('home')" />
          <!-- <hr />
        <br /> -->
        </div>
        <div class="card">
          <p class="field-name">{{ $t("profile.work-address") }}</p>
          <i class="fa fa-briefcase l-icon" />
          <span class="single-line no-scrollbar">{{ workAddress }}</span>
          <i :class="editClass" @click="editAddress('work')" />
          <!-- <hr /> -->
        </div>
        <div v-if="user">
          <!-- <br /> -->
          <div class="card">
            <p class="field-name">{{ $t("profile.email") }}</p>
            <i class="fa fa-envelope l-icon" />
            <span class="single-line no-scrollbar">{{ email }}</span>
            <i :class="editClass" @click="editEmail" />
            <!-- <hr />
          <br /> -->
          </div>
          <div class="card">
            <p class="field-name">
              {{ $t("notifications") }}
              <i v-if="$store.getters.isSuperUser" class="is-pulled-right has-text-weight-medium"
                @click="toggleForceSMSOff">
                <span v-if="forceSMSOff"> Undo Force SMS OFF </span>
                <span v-else class="has-text-danger">Force SMS OFF?</span>
              </i>
            </p>
            <i class="fa fa-bell l-icon" />
            <span class="notification-btn" @click="preToggleSMS">
              <i class="fa fa-circle" :class="smsOn ? 'has-text-success' : 'has-text-danger'" />
              SMS
              <!-- <i class="fa fa-sms" /> -->
            </span>
            &nbsp;
            <span class="notification-btn" @click="preToggleEmail">
              <i class="fa fa-circle" :class="emailOn ? 'has-text-success' : 'has-text-danger'" />
              {{ $t("profile.email") }}
              <!-- <i class="far fa-envelope" /> -->
            </span>
            &nbsp;
            <span class="notification-btn" @click="appNotificationInfo">
              <i class="fa fa-circle" :class="user.notification_token
                ? 'has-text-success'
                : 'has-text-danger'
                " />
              {{ $t("App") }}
              <!-- <i class="fa fa-mobile-alt" /> -->
            </span>
            &nbsp;
            <span class="notification-btn" @click="preToggleSound">
              <i class="fa fa-circle" :class="soundOff ? 'has-text-danger' : 'has-text-success'" />
              {{ $t("Sound") }}
              <!-- <i class="fa fa-bullhorn" /> -->
            </span>
            <!-- <hr /> -->
          </div>
        </div>
        <!-- </div> -->
        <!-- </div> -->
        <!-- </div> -->

        <!-- <div class="card">
          <div class="card-content">
            <div class="content has-text-left">
              <p class="field-name">{{ $t("profile.superpower") }}</p>
              <i class="fa fa-magic" />
              <span class="superpowers" v-if="!superpower">
                <i style="padding-right: 6px">{{ $t("choose-one") }}:</i>
                <i
                  class="fa fa-user-graduate"
                  @click="setSuperpower('student')"
                />&nbsp;
                <i
                  class="fa fa-clinic-medical"
                  @click="setSuperpower('nurse')"
                />&nbsp;
                <i class="fa fa-laptop-code" @click="setSuperpower('nomad')" />
              </span>
              <span v-else>
                <span style="padding-left: 20px">{{
                  $t(`profile.superpower-${superpower}`)
                }}</span
                >&nbsp;
                <i :class="editClass" @click="setSuperpower(null)" />
              </span>
              <hr />
            </div>
          </div>
        </div> -->

        <div class="buttons" style="margin: 25px 16px">
          <a :class="helpButtonClass" href="https://m.me/tukapp" target="_blank">
            <i class="fab fa-facebook-messenger is-large" />
            &nbsp;{{ $t("profile.support") }}
          </a>
          <br />
          <a :class="helpButtonClass" href="https://www.facebook.com/tukapp" target="_blank">
            <i class="fab fa-facebook" />&nbsp;Facebook
          </a>
          <!-- <a
            :class="helpButtonClass"
            href="https://www.instagram.com/tuk_app"
            target="_blank"
          >
            <i class="fab fa-instagram" />&nbsp;Instagram
          </a> -->
          <a :class="helpButtonClass" href="https://web.tukapp.co" target="_blank">
            <i class="fas fa-globe" />&nbsp;Website
          </a>
        </div>

        <div style="position: relative; padding-bottom: 40px; text-align: center">
          <button v-if="$store.getters.isLoggedIn" class="button is-danger is-outlined is-rounded" @click="logout">
            {{ $t("logout.logout") }}
          </button>
          <button v-else class="button is-primary is-rounded" @click="openLogin">
            {{ $t("login.login") }}
          </button>

          <span class="button is-white version" @click="activateSecret">
            v{{ $store.state.version }}
          </span>

          <a v-show="$store.state.secret >= 3" class="button has-text-success is-white wand" @click="secretPopup">
            <i class="fa fa-magic" />
          </a>
        </div>
      </div>
    </div>
    <UserAddressModal @submitAddress="saveAddress" />
  </div>
</template>

<script>
import { sounds } from "../functions.js";
import UserAddressModal from "@/components/UserAddressModal.vue";

export default {
  data() {
    return {
      pendingMobileUpdate: false,
      addressType: "",
      editClass: "fa fa-pencil-alt has-text-info is-pulled-right",
      helpButtonClass: "button is-link is-outlined is-fullwidth",
    };
  },
  components: {
    UserAddressModal,
  },
  mounted() {
    if (this.$route.path === "/logout") this.logout();
  },
  computed: {
    superpower() {
      return this.$store.state.superpower;
    },
    user() {
      return this.$store.state.user;
    },
    fullName() {
      if (!this.user) return null;
      return this.user.data.full_name;
    },
    emailOn() {
      return this.user.data.email;
    },
    soundOff() {
      return this.user.data.sound === "off";
    },
    smsOn() {
      // if (!this.user) return null;
      return this.user.data.sms;
    },
    forceSMSOff() {
      // if (!this.user) return null;
      return this.user.data.force_sms_off;
    },
    email() {
      // if (!this.user) return null;
      return this.user.email;
    },
    referredBy() {
      return this.user.data.referred_by;
    },
    referralCode() {
      if (!this.user.data) return null;
      return this.user.data.referral_code; // || "ABCDEF";
    },
    theme() {
      return this.$store.state.theme;
    },
    homeAddress() {
      var home = this.getAddress("home");
      if (!home) return null;
      return home.name;
    },
    workAddress() {
      var work = this.getAddress("work");
      if (!work) return null;
      return work.name;
    },
  },
  methods: {
    appNotificationInfo() {
      if (this.user.notification_token) {
        this.successToast("App notifications are enabled");
      } else {
        var msg = `App notifications are NOT enabled<br>Please turn them on<br>in your system settings<br>so you don't miss important alerts<br>about your ongoing orders 🙏🏼`;
        this.errorToast(msg, "bottom", 10000);
      }
    },
    activateSecret() {
      this.$store.commit("incrementSecret");
      if (this.$store.state.secret === 3) sounds("mystery_short");
      else if (this.$store.state.secret === 0) sounds("unsafe");
      else sounds("navigate1");
    },
    setSuperpower(superpower) {
      this.$store.commit("setSuperpower", superpower);
    },
    secretPopup() {
      setTimeout(() => this.makeBenchmark(), 500);
      var login = this.$store.state.loginMethod.toUpperCase();
      var region = this.$store.state.region;
      var rideCount = this.$store.state.rideCount;
      var coords = this.$store.getters.getUserLocationString;
      var latency = this.$store.state.systemSpeed;
      var benchmark = this.$store.state.cpuBenchmark;
      var speed = "not supported";
      if (navigator.connection) {
        speed = navigator.connection.downlink + " Mbps";
      }
      this.$swal({
        title: process.env.VUE_APP_TITLE,
        html: `
        <div style="font-size: 0.8em; text-align: left">
        <p>Host ${process.env.VUE_APP_HOST}</p>
        <p>API ${process.env.VUE_APP_API}</p>
        <p>Ride Count <strong>${rideCount}</strong></p>
        <p>Region <strong>${region}</strong></p>
        <p>Coords <strong>${coords}</strong></p>
        <p>Logged in via <strong>${login}</strong></p>
        <p>Download speed <strong>${speed}</strong></p>
        <p>API latency <strong>${latency} ms</strong></p>
        <p>CPU benchmark <strong>${benchmark} micro</strong></p>
        <p>user_id <strong>${this.userID()}</strong></p>
        </div>`,
        showCloseButton: true,
        confirmButtonText: "Clear Cache",
        confirmButtonColor: this.bulmaColor("primary"),
        customClass: { popup: "ccc" },
      }).then((result) => {
        if (result.value) this.clearCacheAndReload();
      });
    },
    preToggleEmail() {
      var title = "Email Settings";
      var txt1 = `Turn Email ON or OFF`;
      var txt2 = `We send email notifications about your ongoing order status.`;
      // var txt3 = `If you are receiving TUK App notifications it's safe to turn this off.`;
      var buttonText = "Turn Email OFF";
      if (!this.emailOn) buttonText = "Turn Email ON";
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'><i class='far fa-envelope'></i>&nbsp;${title}</p>
        <p style='margin-bottom:10px'>${txt1}</p>
        <p style='margin-bottom:10px;'>${txt2}</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: buttonText,
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: this.emailOn
          ? this.bulmaColor("danger")
          : this.bulmaColor("success"),
      }).then((val) => {
        if (val.value) this.toggleEmail();
      });
    },
    preToggleSound() {
      var title = "Sound Settings";
      var txt1 = `Turn In-App Sound ON or OFF`;
      var txt2 = `We make sounds sometimes`;
      // var txt3 = `If you are receiving TUK App notifications it's safe to turn this off.`;
      var buttonText = "Turn Sound OFF";
      if (this.soundOff) buttonText = "Turn Sound ON";
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'><i class='far fa-envelope'></i>&nbsp;${title}</p>
        <p style='margin-bottom:10px'>${txt1}</p>
        <p style='margin-bottom:10px;'>${txt2}</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: buttonText,
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: this.soundOff
          ? this.bulmaColor("success")
          : this.bulmaColor("danger"),
      }).then((val) => {
        if (val.value) this.toggleSound();
      });
    },
    preToggleSMS() {
      var title = "SMS Settings";
      var txt1 = `Turn SMS ON or OFF`;
      var txt2 = `We send notifications about your ongoing order status.`;
      var txt3 = `If you are receiving TUK App notifications it's safe to turn this off.`;
      var buttonText = "Turn SMS OFF";
      if (!this.smsOn) buttonText = "Turn SMS ON";
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'><i class='fa fa-sms'></i>&nbsp;${title}</p>
        <p style='margin-bottom:10px'>${txt1}</p>
        <p style='margin-bottom:10px;'>${txt2}</p>
        <p style='color:grey; font-size:0.85em'><i>${txt3}</i></p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: buttonText,
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: this.smsOn
          ? this.bulmaColor("danger")
          : this.bulmaColor("success"),
      }).then((val) => {
        if (val.value) this.toggleSMS();
      });
    },
    toggleSMS() {
      var data = { data: { sms: !this.smsOn } };
      this.updateUserSettings(data);
    },
    toggleEmail() {
      var data = { data: { email: !this.emailOn } };
      this.updateUserSettings(data);
    },
    toggleSound() {
      let sound = "off"
      if (this.soundOff) sound = "on"
      var data = { data: { sound: sound } };
      this.updateUserSettings(data);
    },
    toggleForceSMSOff() {
      var data = { data: { force_sms_off: !this.forceSMSOff } };
      this.updateUserSettings(data);
    },
    updateUserSettings(data) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("updateUserSettings", data)
        .then((res) => console.log("updateUserSettings", res.data))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    // need to handle worker / transaction cases (?)
    logout() {
      if (this.$store.state.isWorking) {
        var text = this.$t("driver.stop-work-before-logout"); //"Please stop working before logging out";
        this.warningAlert(text);
        return;
      }
      var title = this.$t("logout.title");
      var body = this.$t("logout.text");
      var red = this.bulmaColor("danger");
      this.$swal({
        title: `<i class='fa fa-exclamation-triangle fa-2x' style='color:${red}'></i>`, //"Are you sure?",
        html: `<p><strong style='font-size:1.3em'>${title}</strong></p>
        <p>${body}</p>`, //"If you logout you may loose your account",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("logout.keep-account"), // "Keep my account"
        cancelButtonText: this.$t("logout.really-logout"), // "Really logout"
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("info"),
      }).then((result) => {
        if (result.value) {
          this.$swal({
            title: "Phewwww",
            text: "Your account is safe!",
            timer: 2000,
          });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: this.$t("logout.bye"), //"Until Next Time!"
            html: `<i class="fa fa-hand-peace fa-4x" style="color:lightgreen"/>`,
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.$store
              .dispatch("logout")
              .catch((err) => console.warn("logout error", err));
          }); // need to handle worker / transaction cases (?)
        }
      });
    },
    openLogin() {
      this.loginOkay();
    },
    editRealName() {
      // if driver don't allow to edit name
      if (this.$store.getters.isDriver && this.$store.getters.realName) {
        var err = `Drivers cannot change names<br>Contact Support if you need help`;
        this.infoToast(err, "top");
        if (!this.isSuperUser()) return;
      }
      if (this.loginOkay("Login to edit your name")) {
        this.$swal({
          html: `<div style='text-align:left'>
          <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='far fa-user'></i>&nbsp;
          ${this.$t("login.enter-name")}</p>
          <p>${this.$t("login.can-be-nickname")}</p>
          </div>`,
          input: "text",
          inputValue: this.$store.getters.realName,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonText: this.$t("save"), //"Save",
          inputValidator: (val) => {
            if (!val) {
              return this.$t("login.must-enter-name");
            }
            if (val.length < 4) {
              return "Must be at least 4 characters.<br>If shorter add your second name.";
            }
            this.$store.dispatch("setRealName", val);
            // this.$store.commit("setRealName", val);
          },
        });
      }
    },
    editMobileNumber() {
      if (this.loginOkay("Login to edit your mobile")) {
        if (this.$store.state.loginMethod === "sms") {
          this.changeMobileNumber();
        } else {
          this.setMobileNumber();
        }
      }
    },
    editEmail() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'><i class='far fa-envelope'></i>&nbsp;Enter your email</p>
        </div>`,
        input: "text",
        inputValue: this.user.email,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: this.$t("save"),
        inputValidator: (val) => {
          if (!val) return this.$t("Please enter a real email"); //"You must enter your name!";
          var loader = this.loadingDots("yellow");
          this.$store
            .dispatch("setEmail", val)
            .then((res) => console.log("setEmail", res.data))
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        },
      });
    },
    changeMobileNumber() {
      this.$swal({
        html: `<div style='text-align:left'>
<p style='margin-bottom:10px; font-size:1.2em'><i class='fa fa-mobile-alt'></i>&nbsp;Update mobile number</p>
<p style='margin-bottom:8px'>If you've changed your mobile number please update it here.</p>
<p>Your current mobile number is: <code>${this.user.phone_number}</code></p>
        </div>`,
        input: "text",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: this.$t("update"),
        inputValidator: (val) => {
          if (!val || val.length < 8) {
            return this.$t("Enter a mobile phone number");
          }
        },
      }).then((val) => {
        if (val.value) {
          var newMobile = val.value;
          var name = this.$store.getters.getNameAndNumber;
          var msg = `User ${name} wants to change their mobile number to ${val.value}`;
          this.sendSuperuserNotification(msg);
          this.sendEmailUpdateMobile(newMobile);
          var loader = this.loadingDots("gold");
          setTimeout(() => {
            loader.hide();
            this.pendingMobileUpdate = true;
            this.$swal({
              html: `<div style='text-align:left'>
              <p style='font-size:1.2em; margin-bottom:10px'>Your request to update your mobile is pending.</p>
              <p style='margin-bottom:8px'>Please send a message to our customer service chat or e-mail 
              to ensure we can help you promptly to update your mobile.</p>
              <p>In your message please state your existing mobile
              <code>${this.user.phone_number}</code> 
              and new mobile <code>${newMobile}</code> 🙏🏼</p>
              </div>`,
              showCancelButton: true,
              confirmButtonText: "E-mail Support",
              cancelButtonText: "Chat Support",
              cancelButtonColor: this.bulmaColor("primary"),
            }).then((val) => {
              if (val.value) {
                var email = "nick@tukapp.co";
                var subject = "TUK App 🦜 Update User Mobile Request";
                var body = `I'd like to update my mobile number from ${this.user.phone_number} to ${newMobile}`;
                window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
              } else {
                this.contactFBMessengerSupport();
              }
            });
          }, 600);
        }
      });
    },
    sendEmailUpdateMobile(newMobile) {
      var obj = {
        type: "user_update_mobile",
        user_id: this.$store.state.user.id,
        uuid: this.$store.getters.getUUID,
        current_mobile: this.$store.getters.phoneNumber,
        new_mobile: newMobile,
        name: this.$store.getters.realName,
        app: process.env.VUE_APP_TITLE,
      };
      this.$store.dispatch("sendEmail", obj).catch((err) => console.error(err));
    },
    shareReferralCode() {
      this.$swal({
        html: `<div style='text-align:left'>
      <p style='font-size:1.2em; margin-bottom:12px'>
      <i class='fa fa-share-alt'></i>&nbsp;Share Referral Code
      </p>
      <p style='margin-bottom:10px'>Share this code to invite your friends to TUK.</p>
      <p style='margin-bottom:10px'>When they complete their first TUK order you're both automatically entered to the daily lucky draw!</p>
      <p style='margin-bottom:12px'>Share your referral code with more friends for more chances to win!</p>
      <p style='text-align:center; font-size: 1.2em; font-weight:550'>${this.referralCode}</p>
      </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `Share Referral Link&nbsp;<i class='fa fa-share'></i>`,
        cancelButtonText: `Copy Referral Code&nbsp;<i class='fa fa-copy'></i>`,
        cancelButtonColor: this.bulmaColor("primary"),
      }).then((val) => {
        if (val.value) {
          this.shareReferralLink();
        } else {
          this.$copyText(this.referralCode);
          var msg = `Referral code copied to clipboard&nbsp;<i class='fa fa-copy'></i>`;
          this.infoToast(msg);
        }
      });
    },
    shareReferralLink() {
      var text = `Welcome to TUK! Home to the best local eateries and shops. Sign up now for a chance at the daily lucky draw!`;
      var url = `https://tukapp.co/install?rc=${this.referralCode}`;
      if (!navigator.share) {
        this.$copyText(`${text} ${url}`);
        var msg = `Your Referral Link has been copied:<br>${url}`;
        this.infoToast(msg, "top", 9000);
        return;
      }
      navigator
        .share({
          title: "Check out TUK App",
          text: text, //"Get TUK for your local business needs!",
          url: url,
        })
        .catch((err) => console.log("Error sharing", err));
    },
    referredByInfo() {
      var msg = `You've been referred by ${this.referredBy}`;
      this.successToast(msg);
    },
    enterReferralCode() {
      this.$swal({
        html: `<div style='text-align:left'>
      <p style='font-size:1.2em; margin-bottom:12px'>
      <i class='fa fa-tags'></i>&nbsp;Enter Referral Code
      </p>
      <p style='margin-bottom:10px'>You and the person who referred you will be eligible to win in the daily lucky draw!</p>
      <p style='margin-bottom:10px'>Just complete a TUK order and you're automatically entered.</p>
      <p>Share your referral code with friends for more chances to win!</p>
      </div>`,
        input: "text",
        inputPlaceholder: "Referral Code",
        showCloseButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (val) => {
          if (!val) return;
          if (val.length < 6) return "Referral codes have 6 letters";
          if (val === this.referralCode) return "You can't refer yourself";
          var goTime = this.golangTimestamp();
          var data = {
            data: { referred_by: val.toUpperCase(), referred_at: goTime },
          };
          this.updateUserSettings(data);
        },
      });
    },
    changeLanguage() {
      this.openLanguageSelector();
    },
    saveAddress(val) {
      // first set addressType
      val.address_type = this.addressType;
      val.user_id = this.$store.state.user.id;
      this.console("saveAddress", val);
      var loader = this.loadingDots("gold");
      this.$store
        .dispatch("saveUserAddress", val)
        .then(() => {
          this.$store.dispatch("getUserAddresses");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    editAddress(addressType) {
      // home or work for now
      if (this.loginOkay("Login to edit your addresses")) {
        this.addressType = addressType;
        var className = ".user-address-modal";
        this.$el.querySelector(className).classList.add("is-active");
      }
    },
  },
};
</script>

<style scoped>
.info-tab {
  overflow: auto;
  height: calc(100vh - 180px);
  text-align: left;
}

.dark {
  /* background-color: #123; */
  background-color: rgb(59, 59, 59);
  color: white;
}

.card {
  box-shadow: initial;
  margin-top: 6px;
  padding: 12px;
}

.dark .card {
  background-color: #1f1b2494;
  color: lightslategrey;
}

hr {
  margin: 0 0;
}

.dark hr {
  background-color: rgba(255, 255, 255, 0.15);
}

.field-name {
  margin-bottom: 0;
  /* line-height: 0pt; */
  font-size: 0.8em;
  opacity: 0.6;
}

.card-content {
  /* default padding is 24px */
  padding: 18px;
}

.wand {
  position: absolute;
  left: 0;
  background-color: rgba(255, 255, 255, 0);
  /* padding: 5px 12.5px; */
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.tag.is-rounded {
  padding: 9px;
}

.version {
  position: absolute;
  right: 0;
  background-color: rgba(255, 255, 255, 0);
}

.fa {
  color: grey;
}

.fa-pencil-alt {
  opacity: 0.6;
}

.superpowers {
  padding-left: 10px;
  color: grey;
}

.superpowers .fa {
  padding: 0 6px;
}

.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
  max-width: calc(100vw - 100px);
  vertical-align: bottom;
}

.l-icon {
  width: 33px;
}

.notification-btn {
  padding: 0 4px;
  padding-top: 2px;
  border-radius: 3px;
  box-shadow: 0 0 2px rgb(212, 212, 212);
}

.btn-on {
  background-color: var(--success);
}

.btn-off {
  background-color: red;
}

.dark .pulse-btn {
  color: white;
}

.pulse-btn {
  /* border-radius: 25px; */
  animation: shadow-pulse-gold 2s ease-out infinite;
}

@keyframes shadow-pulse-gold {
  0% {
    box-shadow: inset 0 0 0 0px rgb(0, 255, 100);
  }

  50% {
    box-shadow: inset 0 0 0 14px rgba(0, 255, 0, 0.2);
  }

  100% {
    box-shadow: inset 0 0 0 0px rgba(0, 255, 255, 0.5);
  }
}
</style>

<style>
.ccc {
  border-radius: 25px;
}
</style>